import type { AxiosResponse } from "axios";

import { HttpApiService } from "@/shared/services/httpApi.service";

/** Bre-B key resolved in the directory, as served by `GET /internal/payments/breb-keys/:value`. */
export interface BrebKeyResolution {
  key_type: string;
  key_value: string;
  /** Directory status — only `ACTIVE` keys can receive. */
  status: string;
  /** Masked holder name, e.g. "Ale*** Pul***". */
  holder_name: string;
  id_type: string | null;
  /** Masked holder document, e.g. "***031". */
  id_number: string | null;
  bank_name: string | null;
}

/**
 * Bre-B key resolution for the dispersion form (rail-named endpoint — the API hides which PSP serves it).
 * Returns the masked holder identity so the operator confirms who receives BEFORE creating the payout; the
 * backend resolves the key again at dispatch, so this call is informative only. A key the directory does not
 * recognize answers 404.
 */
export class BrebKeysService {
  private static BASE_URL = "/internal/payments/breb-keys";

  static async resolve(keyValue: string): Promise<AxiosResponse<BrebKeyResolution>> {
    return HttpApiService.get<BrebKeyResolution>(`${this.BASE_URL}/${encodeURIComponent(keyValue)}`);
  }
}
